export const ADD_SEARCH_ITEM = 'add-search-item';
export const ADD_CATEGORY = 'add-category';
export const ADD_AUTHOR = 'add-author';
export const CLEAR_FILTER = 'clear-filter';
